import { createAPIActions } from 'barnyard/utils';

const NAME = 'alerts';
// alert API actions
export const ALERTS_FETCH = createAPIActions(`${NAME}/ALERTS_FETCH`);
export const ALERT_DISMISS = createAPIActions(`${NAME}/ALERT_DISMISS`);
// alert socket messages
export const NEW_ALERT = 'NEW_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
// alert severity levels
export const ALERT_INFO = 'INFO';
export const ALERT_WARNING = 'WARNING';
export const ALERT_DANGER = 'DANGER';
export const ALERT_SUCCESS = 'SUCCESS';
export const ALERT_CELEBRATION = 'CELEBRATION';
// alert display locations
export const SNACKBAR = 'SNACKBAR';
export const HOMEPAGE = 'HOMEPAGE';
// Redirects
export const INTERCOM_LINK = 'open_intercom';
